// /src/components/NodeEditorPanel.jsx
import React, { useEffect, useState } from 'react';

const NodeEditorPanel = ({ selectedNode, onSave, onClose }) => {
  const [name, setName] = useState('');
  const [type, setType] = useState('formulario');
  const [configJson, setConfigJson] = useState('{}');

  useEffect(() => {
    if (selectedNode) {
      setName(selectedNode.data?.label || '');
      setType(selectedNode.data?.type || 'formulario');
      setConfigJson(selectedNode.data?.configJson || '{}');
    }
  }, [selectedNode]);

  const handleSave = () => {
    const updatedData = {
      ...selectedNode.data,
      label: name,
      type,
      configJson,
    };
    onSave(selectedNode.id, updatedData);
  };

  if (!selectedNode) return null;

  return (
    <div
      style={{
        position: 'absolute',
        right: 0,
        top: 0,
        width: 300,
        height: '100%',
        background: '#f4f4f4',
        padding: 16,
        boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',
        overflowY: 'auto',
      }}
    >
      <h3>Editar Paso</h3>

      <label>Nombre</label>
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />

      <label>Tipo</label>
      <select
        value={type}
        onChange={(e) => setType(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      >
        <option value="formulario">Formulario</option>
        <option value="validacion">Validación</option>
        <option value="documento">Documento</option>
        <option value="informativo">Informativo</option>
      </select>

      <label>Configuración JSON</label>
      <textarea
        value={configJson}
        onChange={(e) => setConfigJson(e.target.value)}
        rows={6}
        style={{ width: '100%' }}
      />

      <button onClick={handleSave} style={{ marginTop: 10, marginRight: 10 }}>
        Guardar
      </button>
      <button onClick={onClose}>Cerrar</button>
    </div>
  );
};

export default NodeEditorPanel;
